<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />

    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">
        {{
          onlyRead
            ? App.ModalDeclineRequest.REASON_REFUSED
            : General.DECLINE_REQUEST
        }}
      </span>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>

    <section class="modal-card-body spacing-p-10">
      <span class="has-text-color-7 spacing-mb-10 has-text-weight-semibold"
        >{{ App.ModalDeclineRequest.REASON_REFUSED }}:</span
      >
      <div class="spacing-mt-5 columns">
        <div
          v-for="refuse_item in refuse_option_list"
          :key="refuse_item[0]"
          class="check-tag"
        >
          <b-radio
            v-model="refuse_option"
            class="has-text-color-7"
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            :nativeValue="refuse_item[0]"
            :disabled="onlyRead"
          >
            {{ refuse_item[1] }}
          </b-radio>
        </div>
      </div>
      <span class="has-text-color-7 spacing-mb-10 has-text-weight-semibold"
        >{{ App.ModalDeclineRequest.DESCRIPTION_REASON_REFUSED }}:</span
      >
      <b-field class="description">
        <b-input
          v-model="refuse_justification"
          :disabled="onlyRead"
          maxlength="500"
          type="textarea"
          iconClickable
          :placeholder="General.TEXTS.DETAIL_REASON_REFUSED"
        />
      </b-field>
    </section>

    <footer
      v-if="!onlyRead"
      class="modal-card-foot is-justify-content-flex-end"
    >
      <div class="buttons">
        <b-button
          :type="isContrast ? 'is-white-dark' : 'is-primary'"
          @click="goDeclineRequest"
        >
          {{ General.DECLINE.toUpperCase() }}
        </b-button>

        <b-button
          :type="isContrast ? 'is-white-dark' : 'is-warning'"
          outlined
          @click.stop="close()"
        >
          {{ General.CANCEL.toUpperCase() }}
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import { General, App } from "@/utils/constants";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalDeclineRequest",

  props: {
    signatureList: {
      type: Array,
      default: () => []
    },
    onClose: {
      type: Function,
      default: () => null
    },
    fieldRefuseOption: {
      type: String,
      default: ""
    },
    fieldRefuseJustification: {
      type: String,
      default: ""
    },
    onlyRead: {
      type: Boolean,
      default: false
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    hash: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      App,
      General,
      refuse_option: "",
      refuse_justification: "",
      isLoading: false,
      refuse_option_list: Object.entries(App.ModalDeclineRequest.REASONS)
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },

  beforeMount() {
    if (this.onlyRead) {
      this.refuse_option = this.fieldRefuseOption;
      this.refuse_justification = this.fieldRefuseJustification;
    }
  },

  methods: {
    ...mapActions({
      refuseExternalSignature: "refuseExternalSignature",
      refuseSignatureFile: "refuseSignatureFile"
    }),

    async goDeclineRequest() {
      this.isLoading = true;
      let msg = "";

      if (!this.refuse_option.length)
        msg = this.General.MESSAGES.SELECT_AN_REANSON;
      else if (!this.refuse_justification.length)
        msg = this.General.TEXTS.INSERT_REASON_REFUSE;
      else if (!this.signatureList.length && !this.isExternal)
        msg = this.General.MESSAGES.NO_RECORDS_FOUND;

      if (msg.length) {
        this.snackToast.open({
          message: `${msg}.`,
          type: "is-danger",
          duration: 8000
        });
      } else {
        if (!this.isExternal) {
          const refusedList = this.signatureList.map(doc => ({
            signature_file_id: doc.id,
            refuse_justification: this.refuse_justification,
            refuse_option: this.refuse_option
          }));

          await this.refuseSignatureFile(refusedList);

          await this.$store.dispatch("documentSignRequest", {
            page: 1,
            order_by: "created_at"
          });
        } else {
          const refuse_options = {
            refuse_justification: this.refuse_justification,
            refuse_option: this.refuse_option
          };
          await this.refuseExternalSignature({
            hash: this.hash,
            refuse_options
          });
        }
        this.close();
      }
      this.isLoading = false;
    },

    close() {
      this.onClose && this.onClose();
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.close-button {
  z-index: 2;
}

.up-25 {
  top: -25px;
  position: relative;
}

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 350;
  max-height: 75vh;
  background-color: $color-1;
  font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}

.modal-card-body {
  background-color: transparent;
}

.spacing-mt-5.columns {
  margin-left: 0px;
  margin-right: 10px;
}

.custom-self-align-end {
  align-self: flex-end;
}

.spacing-mb-20 {
  margin-bottom: 10px !important;
}
</style>
